import { render, staticRenderFns } from "./prop_map.vue?vue&type=template&id=b4cad7b4&scoped=true&"
import script from "./prop_map.vue?vue&type=script&lang=js&"
export * from "./prop_map.vue?vue&type=script&lang=js&"
import style0 from "./prop_map.vue?vue&type=style&index=0&id=b4cad7b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cad7b4",
  null
  
)

export default component.exports